import { render, staticRenderFns } from "./CartComponent.vue?vue&type=template&id=28ba35b8&scoped=true&"
import script from "./CartComponent.vue?vue&type=script&lang=js&"
export * from "./CartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba35b8",
  null
  
)

export default component.exports